import React, { useMemo } from 'react'

// Faint paper grain + dust-motes-in-lamplight atmosphere layer.
// Pure CSS animation (transform/opacity only), ≤24 elements, cheap.
// Respects prefers-reduced-motion via global.css media query.
export function Atmosphere({ count = 20 }: { count?: number }) {
  const motes = useMemo(() => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      left: Math.round(Math.random() * 100),
      top: Math.round(60 + Math.random() * 40),
      size: 1.5 + Math.random() * 2.5,
      duration: 14 + Math.random() * 16,
      delay: Math.random() * -20,
      variant: i % 2 === 0 ? 'p-mote-a' : 'p-mote-b',
    }))
  }, [count])

  return (
    <>
      <div className="p-grain" />
      <div className="p-atmosphere" aria-hidden="true">
        {motes.map((m) => (
          <div
            key={m.id}
            className={`p-mote ${m.variant}`}
            style={{
              left: `${m.left}%`,
              top: `${m.top}%`,
              width: m.size,
              height: m.size,
              animationDuration: `${m.duration}s`,
              animationDelay: `${m.delay}s`,
            }}
          />
        ))}
      </div>
    </>
  )
}
